export default [
  {
    isEnabled: true,
    name: 'dashboard',
  },
  {
    isEnabled: true,
    name: 'team_activity',
  },
  {
    isEnabled: true,
    name: 'account_control',
  },
  {
    isEnabled: true,
    name: 'global_settings',
  },
  {
    isEnabled: true,
    name: 'custom_terms_of_use',
  },
  {
    isEnabled: true,
    name: 'enterprise_only_integrations',
  },
  {
    isEnabled: true,
    name: 'customer_success_manager',
  },
  {
    isEnabled: true,
    name: 'contributor_seats',
  },
  {
    isEnabled: true,
    name: 'web_social_email_responses',
  },
  {
    isEnabled: true,
    name: 'mobile_apps_ios_android',
  },
  {
    isEnabled: true,
    name: 'custom_question_bank',
  },
  {
    isEnabled: true,
    name: 'quiz_scoring_and_instant_results',
  },
  {
    isEnabled: true,
    name: 'custom_subdomain',
  },
  {
    isEnabled: true,
    name: 'word_cloud_combine_hide',
  },
];
